module.exports = __webpack_public_path__ + "static/media/Oricorio_gaussian2.3efe306f.png";